/** actions for fetching and setting damz-wide search from the app header searchbar
 *  and message/fulltext search from the sidebar searchbar */
import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { reduxKey } from '../../constants';
import { SearchState } from '../selectors/search';

export const clearSearchQuery = createAction(
  `${reduxKey}.DAMZ_CLEAR_SEARCH_QUERY`,
  () => ({})
);

export const closeSearchUI = createAction(
  `${reduxKey}.CLOSE_SEARCH_UI`,
  () => ({})
);

// ---- main/autocomplete search
export const fetchAutocompleteSearch = createAction(
  `${reduxKey}.DAMZ_FETCH_AUTOCOMPLETE_SEARCH`,
  (q: SearchState['q']) => ({ q })
);

export const fetchAutocompleteSearchSuccess = createAction(
  `${reduxKey}.DAMZ_FETCH_AUTOCOMPLETE_SEARCH_SUCCESS`,
  (results: SearchState['results']) => ({ results })
);

// ---- keyword/messages search
export const setIsSearchingMessages = createAction(
  `${reduxKey}.DAMZ_SET_IS_SEARCHING_MESSAGES`,
  (isSearchingMessages: boolean) => ({ isSearchingMessages })
);

export const initMessageSearchStream = createAction(
  `${reduxKey}.DAMZ_INIT_MESSAGE_SEARCH_STREAM`,
  (q: SearchState['q']) => ({ q })
);

export const fetchMessageSearchNext = createCallbackActionCreator(
  `${reduxKey}.DAMZ_FETCH_MESSAGE_SEARCH_NEXT`
);

export const fetchMessageSearchSuccess = createAction(
  `${reduxKey}.DAMZ_FETCH_MESSAGE_SEARCH_SUCCESS`,
  (results: SearchState['results']) => ({ results })
);

export const setMessageSearchOrder = createAction(
  `${reduxKey}.DAMZ_SET_MESSAGE_SEARCH_ORDER`,
  (order: SearchState['order']) => ({ order })
);
